// ---------------------------------------------------------------------------
// Lead Source (UTM) mapping table.
// EDIT THIS TABLE as marketing campaigns are added or renamed over time.
// Each row matches on utm_source + utm_medium + utm_campaign (case-insensitive)
// and maps to a human-readable channel label shown in the Applications dashboard.
// ---------------------------------------------------------------------------
export const LEAD_SOURCE_MAP = [
  { utm_source: 'google',    utm_medium: 'cpc',      utm_campaign: 'core',            label: 'Paid Search – Core' },
  { utm_source: 'google',    utm_medium: 'cpc',      utm_campaign: 'youth-sports',    label: 'Paid Search – Youth Sports' },
  { utm_source: 'google',    utm_medium: 'cpc',      utm_campaign: 'fitness',         label: 'Paid Search – Fitness' },
  { utm_source: 'instagram', utm_medium: 'social',   utm_campaign: 'organic',         label: 'Organic Social – Instagram' },
  { utm_source: 'linkedin',  utm_medium: 'social',   utm_campaign: 'organic',         label: 'Organic Social – LinkedIn' },
  { utm_source: 'facebook',  utm_medium: 'social',   utm_campaign: 'organic',         label: 'Organic Social – Facebook' },
  { utm_source: 'website',   utm_medium: 'referral', utm_campaign: 'homepage',        label: 'Website Organic' },
  { utm_source: 'seo',       utm_medium: 'organic',  utm_campaign: '4000-plus-pages', label: 'SEO' },
  { utm_source: 'seo',       utm_medium: 'organic',  utm_campaign: 'fitness-pages',   label: 'SEO – Fitness Pages' },
  { utm_source: 'meta',      utm_medium: 'paidsocial', utm_campaign: 'youth-sports',  label: 'Paid Social – Youth Sports (Meta)' },
];

export const DIRECT_UNKNOWN = 'Direct/Unknown';

const norm = (v) => (v == null ? '' : String(v).trim().toLowerCase());

// Resolve a UTM triple to its human-readable channel label.
export function getLeadSource(utm_source, utm_medium, utm_campaign) {
  const s = norm(utm_source);
  const m = norm(utm_medium);
  const c = norm(utm_campaign);
  if (!s && !m && !c) return DIRECT_UNKNOWN;
  const match = LEAD_SOURCE_MAP.find(
    (row) => norm(row.utm_source) === s && norm(row.utm_medium) === m && norm(row.utm_campaign) === c
  );
  return match ? match.label : DIRECT_UNKNOWN;
}

// Distinct channel labels (in table order) + Direct/Unknown, for filter dropdowns.
export function getLeadSourceOptions() {
  const labels = [];
  LEAD_SOURCE_MAP.forEach((row) => {
    if (!labels.includes(row.label)) labels.push(row.label);
  });
  labels.push(DIRECT_UNKNOWN);
  return labels;
}
